export var formatPhoneNumber = function (phoneNumber, countryId) {
    if (['US', 'CA'].includes(countryId.toUpperCase())) {
        return phoneNumber && phoneNumber.length === 10
            ? "(".concat(phoneNumber.substring(0, 3), ") ").concat(phoneNumber.substring(3, 6), "-").concat(phoneNumber.substring(6))
            : phoneNumber;
    }
    else {
        return phoneNumber;
    }
};
export var cleanPhoneNumberFormat = function (phoneNumber) {
    var result = phoneNumber.replace(/[^0-9]/g, '');
    return phoneNumber.startsWith('+') ? "+".concat(result) : result;
};
